export default __webpack_public_path__ + "static/media/img-0660-lithuania-premium-face.962967fe.png";